import React from 'react'
import parse from 'html-react-parser'
import { Link } from 'gatsby'

import LinkButton from 'shared/Button/LinkButton'

interface Datas {
  datas: {
    allFlamelinkPostContent: {
      nodes: {
        id: number
        slug: string
        title: string
        date: string
        snippet: string
        alt: string
        width: number
        height: number
        image: {
          url: string
        }[]
      }[]
    }
  }
}

const s = {
  container: `w-full h-fit-content`,
  grid: `grid-2 gap-20 mdx:grid-cols-1 mdx:gap-0`,
  card: `relative w-full h-fit-content mdx:mb-20 mdx:last:mb-0`,

  link: `w-full h-full`,
  image: `w-full h-h34 object-cover -scale-x-100 2xlm:h-h37 xlm:h-h45 lgm:h-h41 mdm:h-h50 smm:h-h55 xsx:h-h32`,

  body: `absolute top-12 left-12 z-1 w-1/2 h-12/12 flex flex-col p-12 bg-offwhite rounded 
  mdx:relative mdx:top-0 mdx:left-0 mdx:w-full mdx:px-0 mdx:pb-0`,
  title: `mb-0 text-h4`,
  date: `mb-6 text-sm`,
  snippet: `mb-10 flex-grow text-sm leading-relaxed text-darkgray`,
  button: `w-full text-center mdx:w-fit-content`,
}

const Content = ({ datas }: Datas) => {
  const posts = datas.allFlamelinkPostContent.nodes

  return (
    <div className={s.container}>
      <div className={s.grid}>
        {posts.map(
          ({ id, slug, title, date, snippet, alt, width, height, image }) => (
            <div key={id} className={s.card}>
              <Link className={s.link} to={`/post/${slug}/`} aria-label={title}>
                <img
                  className={s.image}
                  src={image[0].url}
                  alt={alt}
                  width={width}
                  height={height}
                />
              </Link>
              <div className={s.body}>
                <h3 className={s.title}>{title}</h3>
                <p className={s.date}>{date}</p>
                <div className={s.snippet}>{parse(snippet)}</div>

                <LinkButton classname={s.button} to={`/post/${slug}/`}>
                  Read News
                </LinkButton>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default Content
